import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as MDICONS from '@material-ui/icons';
import { includeIntoProjectAccept } from '../../../store/actions/projectActions';
import firebaseConfig from '../../../config/firebaseConfig';

class ProjectAcceptRequest extends Component {
    constructor(props) {
        super(props)

        this.state = {
            requestMaker: {},
            allTagsSelectedCheck: false,
            selectedTagsIdList: [],
            accessLevelRadio: -1,
        }
    }

    /// README: HANDLE TAG SELECTION AND REMOVAL
    handleTagSelect = (tagMap) => {
        const { selectedTagsIdList } = this.state;
        var newSelectedTagIdList = selectedTagsIdList;
        if (selectedTagsIdList.indexOf(tagMap.tagid) === -1) {
            if (selectedTagsIdList.length < 5) {
                newSelectedTagIdList = [...newSelectedTagIdList, tagMap.tagid];
            } else {
                alert("More than 5 tags is not allowed!");
            }
        } else {
            newSelectedTagIdList = newSelectedTagIdList.filter(stagid => stagid !== tagMap.tagid);
        }

        this.setState({
            selectedTagsIdList: newSelectedTagIdList,
        })
    }

    handleAllTagsSelectionToggle = (e) => {
        this.setState({
            [e.target.id]: !this.state.allTagsSelectedCheck
        })
    }


    handleAccessToggle = (accessLevelRadio) => {
        this.setState({
            accessLevelRadio,
        })
    }

    handleSubmit = () => {
        const { allTagsSelectedCheck, accessLevelRadio, selectedTagsIdList } = this.state;
        const { notificationItem, companyData, userData } = this.props;
        const { requestMaker, project } = notificationItem;

        console.log(userData, requestMaker, project, allTagsSelectedCheck, selectedTagsIdList, accessLevelRadio);
        this.props.includeIntoProjectAccept(userData, requestMaker, project, allTagsSelectedCheck, selectedTagsIdList, accessLevelRadio);
    }

    async componentDidMount() {
        const { alu, notificationItem, companyData } = this.props;
        const { accessList } = companyData;

        /// get fresh requester data to check if he/she has been already allotted an employee id
        const requestMaker = (await firebaseConfig.firestore().collection('Users').doc(notificationItem.requestMaker.uid).get()).data();
        console.log(requestMaker)
        const ueid = requestMaker.uid + requestMaker.employeeid;
        const isInsider = [...accessList].includes(ueid);

        this.setState({
            requestMaker,
            accessLevelRadio: isInsider ? alu.employee : alu.outsider,
        })
    }

    render() {
        const labelStyling = {
            marginLeft: "10px",
        }

        const { notifUtils, notificationItem, modalStyles,
            modalTitleStyle, formLabelStyle, modalWidth,
            companyData, alu, themeColors,commons
        } = this.props;
        const {defectMarkers} =commons;
        const { accessLevelRadio, allTagsSelectedCheck, selectedTagsIdList, requestMaker } = this.state;

        const { isCompanyInsider, projectRolesForInternals, projectRolesForExternals } = alu;

        const { notificationIcon } = notifUtils;
        const { notify, requestCode, timestamp, project } = notificationItem;
        const momentFromNow = moment(timestamp.toDate()).fromNow();
        const notifIcon = notificationIcon[requestCode];

        const { accessList } = companyData;
        const ueid = requestMaker.uid + requestMaker.employeeid;
        const isInsider = [...accessList].includes(ueid);
        const relevantProjectRoles = isInsider ? projectRolesForInternals : projectRolesForExternals;

        return (
            <div className="dynamicModalContainerSm">
                <div className="dynamicModalSm">
                    <h5 style={modalTitleStyle}>Project acceptance request:</h5>
                    <br />
                    <p><span style={{ color: "gray" }}>{notifIcon} <MDICONS.MoreVert /> </span>{notify}<span className="float-right" style={{ color: "gray", fontStyle: "italic" }}><MDICONS.Remove /> {momentFromNow}</span></p>
                    <br />

                    <h5 style={modalTitleStyle}>Requester info:</h5>
                    <br />
                    <ul>
                        <span><b>Name:</b> {requestMaker.name}</span>
                        <br />
                        <span><b>Is insider:</b> {isInsider ? "yes" : "no"}</span>
                    </ul>
                    <br />

                    <h5 style={modalTitleStyle}>Grant access:</h5>
                    <br />
                    <form onSubmit={this.handleSubmit}>
                        <ul>
                            {/* RADIO SELECTOR FOR ACCESS LEVEL */}
                            <div className="form-group">
                                <span><b>Select access level:</b></span>
                                {[...relevantProjectRoles].map((eachRole) => {
                                    const radioId = `${eachRole.title}Radio`;
                                    return (
                                        <div className="form-check" key={eachRole.access}>
                                            <input className="form-check-input" type="radio" name="accessRadios" id={radioId} value="option1" checked={accessLevelRadio === eachRole.access} onChange={() => { this.handleAccessToggle(eachRole.access) }} />
                                            <label style={labelStyling} className="form-check-label" htmlFor={radioId}>{eachRole.title}</label>
                                        </div>
                                    );
                                })}
                            </div>

                            {/* TAG SELECTION */}
                            <div className="form-group text-left">
                                <span><b>Select {defectMarkers}:</b></span>
                                {allTagsSelectedCheck ?
                                    (<React.Fragment />)
                                    :
                                    (
                                        <div className="d-flex justify-content-between">
                                            <div className="d-flex flex-row">
                                                <div className="align-self-center">
                                                    <div className="row row-cols mx-3">
                                                        {'allTagsMap' in project ? Object.keys(project.allTagsMap).length > 1 ? Object.values(project.allTagsMap).sort(this.compare).filter(val => (val.tagid !== "elevation") && (!val.name.includes('[DELETED]'))).map((val, i) => {
                                                            var pillBackgroundColor = selectedTagsIdList.indexOf(val.tagid) > -1 ? themeColors.themeColor : themeColors.themeColorTrans;
                                                            var pillTextColor = selectedTagsIdList.indexOf(val.tagid) > -1 ? "whitesmoke" : themeColors.themeColor;
                                                            return (
                                                                <div key={val.tagid} onClick={() => this.handleTagSelect(val)}>
                                                                    <span className="badge badge-pill mx-1 px-3" role="button" style={{ backgroundColor: `${pillBackgroundColor}`, color: `${pillTextColor}`, textAlign: "end", fontSize: "12px" }}>{val.name ?? "undefined"}</span>
                                                                </div>
                                                            );
                                                        }) : `No ${defectMarkers} found` : `No ${defectMarkers} found`}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>)
                                }
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex flex-row">
                                        <div className="align-self-center">
                                            <div className="custom-control custom-checkbox mt-3">
                                                <input type="checkbox" className="custom-control-input ml-3" id="allTagsSelectedCheck" name="allTagsSelectedCheck" checked={allTagsSelectedCheck} onChange={this.handleAllTagsSelectionToggle} />
                                                <label className="custom-control-label" htmlFor="allTagsSelectedCheck" style={formLabelStyle}>Select all {defectMarkers}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-row">
                                        <div className="align-self-center">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ul>
                        <br />
                        <div className="btn btn-danger btn-sm float-right" onClick={this.handleSubmit}>Accept {commons.project} request</div>
                    </form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        themeColors: state.theme,
        userData: state.firebase.profile,
        notifUtils: state.notifUtils,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        companyData: state.firestore.data.Company,
        alu: state.alu,
        commons:state.commons,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        includeIntoProjectAccept: (acceptorJson, requestMakerJson, projectModelJson, hasAllTags, selectedTagsIdList, selectedLevel) => dispatch(includeIntoProjectAccept(acceptorJson, requestMakerJson, projectModelJson, hasAllTags, selectedTagsIdList, selectedLevel))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectAcceptRequest);